export const container = { position: 'relative', width: '85vw' };
export const msgIcon = {
  paddingLeft: '10px',
  fontSize: '26px',
  color: '#22165f',
  height: '100%',
  with: '100%',
  cursor: 'pointer',
  marginLeft: '0.5rem'
};
export const TemplateBtn = {
  height: '40px',
  marginLeft: '10px',
  marginTop: '47px',
  color: '#22165f',
  background: 'white',
  border: '1px solid'
};

export const cntStyl = {
  width: '300px',
  height: '365px'
};
export const SearchBox = {
  padding: '0px 10px 5px 10px',
  borderBottom: '1px solid #c7c7c7'
};
export const Templates = {
  font: 'normal 16px Inter',
  paddingTop: '5px',
  color: '#23165f',
  marginLeft: '2px',
  marginRight: '10px'
};
export const dflexcnt = {
  display: 'flex',
  padding: '8px',
  background: '#f1f5fe',
  color: '#23165f',
  cursor: 'pointer'
};
export const dflexcntUn = {
  ...dflexcnt,
  background: '#fff'
};
export const footer = {
  position: 'absolute',
  bottom: '0',
  font: 'normal 16px Inter',
  width: '100%',
  borderTop: '1px solid #c7c7c7'
};
export const footerCont = {
  padding: '8px',
  display: 'flex'
};
export const footerContdv = {
  marginLeft: '2px',
  cursor: 'pointer'
};

// Inbox > modal > StageChange.js

export const BtnContainer = {
  marginTop: '30px',
  textAlign: 'center',
  marginLeft: '25px'
};
export const Cancel = {
  width: '150px',
  height: '40px',
  borderRadius: '8px',
  border: '1px solid #023e8a',
  color: '#023e8a',
  backgroundColor: '#ffffff',
  marginRight: '20px'
};
export const SendFeed = {
  width: '150px',
  height: '40px',
  borderRadius: '8px',
  backgroundColor: '#023e8a',
  color: '#fff',
  marginRight: '20px'
};

export const DeleteButton = {
  width: '150px',
  height: '40px',
  borderRadius: '8px',
  backgroundColor: '#f44336',
  color: '#fff',
  marginRight: '20px'
};
export const FontStyle = {
  textAlign: 'center',
  font: 'normal bold 18px Inter',
  marginTop: '-10px',
  color: '#023e8a'
};
